const ROOT_PATH = '/offers';

export const OffersPaths = {
  ROOT_PATH,
} as const;
